
import React, { useId } from 'react';

/**
 * Bone outline next to section titles — same path as SpotlightCarousel “In the Spotlight” bone.
 * Stroke uses `currentColor`; set via `className` (e.g. `text-[#9ca3af]` or `text-black`).
 */
export function FilterSectionBoneIcon({ className = 'shrink-0 text-[#9ca3af]', size = 25 }) {
  const rawId = useId().replace(/:/g, '');
  const clipId = `filter-bone-clip-${rawId}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      fill="none"
      className={className}
      aria-hidden
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M15.1395 3.06973C15.9352 3.06973 16.6982 3.3858 17.2608 3.94841C17.8234 4.51102 18.1395 5.27408 18.1395 6.06973C18.6328 6.06963 19.1186 6.19119 19.5537 6.42365C19.9889 6.65611 20.36 6.99229 20.6341 7.40242C20.9083 7.81255 21.0771 8.28397 21.1256 8.77492C21.1741 9.26588 21.1008 9.76121 20.9121 10.217C20.7234 10.6729 20.4252 11.0752 20.044 11.3882C19.6627 11.7013 19.2101 11.9155 18.7263 12.0119C18.2424 12.1083 17.7423 12.0839 17.2702 11.9408C16.798 11.7978 16.3685 11.5405 16.0195 11.1917L11.2615 15.9497C11.6049 16.2934 11.8597 16.7153 12.004 17.1793C12.1482 17.6432 12.1777 18.1352 12.0898 18.613C12.0019 19.0908 11.7992 19.5401 11.4993 19.9223C11.1994 20.3045 10.8111 20.6081 10.3679 20.8071C9.92466 21.006 9.43975 21.0944 8.95484 21.0645C8.46993 21.0346 7.99953 20.8874 7.58408 20.6356C7.16863 20.3837 6.82056 20.0347 6.5698 19.6186C6.31904 19.2025 6.17309 18.7317 6.1445 18.2467V18.0697H5.9685C5.48333 18.0413 5.01234 17.8954 4.59604 17.6447C4.17973 17.3939 3.83059 17.0457 3.57863 16.6301C3.32668 16.2146 3.17946 15.744 3.14965 15.2589C3.11983 14.7738 3.20832 14.2888 3.40748 13.8454C3.60665 13.4021 3.91053 13.0138 4.293 12.714C4.67546 12.4141 5.12505 12.2117 5.60308 12.124C6.08111 12.0364 6.57327 12.0662 7.03723 12.2109C7.50118 12.3556 7.92304 12.6109 8.2665 12.9547L13.0245 8.19673C12.6048 7.77729 12.3189 7.2428 12.203 6.66087C12.087 6.07893 12.1463 5.47569 12.3732 4.92742C12.6001 4.37916 12.9845 3.9105 13.4778 3.58072C13.9711 3.25095 14.5511 3.07486 15.1445 3.07473L15.1395 3.06973Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="24" height="24" fill="white" transform="translate(0.139496 0.0697327)" />
        </clipPath>
      </defs>
    </svg>
  );
}
